// extracted by mini-css-extract-plugin
export var learning_object = "dlcList-module--learning_object--b09eb";
export var learning_object_list = "dlcList-module--learning_object_list--11530";
export var shrink = "dlcList-module--shrink--ab1d5";